import { ChangeDetectionStrategy, Component, computed, effect, Input, OnInit, signal } from '@angular/core';
import { AbstractBasePanelComponent } from '../utils/abstract-base-panel.component';
import { kebabCase, maxBy } from 'lodash';
import { PackageDto } from '../dto';
import { SkeletonScreenComponent } from '../skeleton-screen/skeleton-screen.component';
import { InputPanelComponent } from '../components/input-panel/input-panel.component';
import { TablerIconsModule } from 'angular-tabler-icons';
import { PanelComponent } from '../panel/panel.component';
import { CurrencyPipe, DatePipe, NgClass } from '@angular/common';
import { AlertComponent } from '../components/alert/alert.component';
import { TranslatePipe } from '@ngx-translate/core';

export type InternetType = 'all-in-one' | 'internet-only';

@Component({
  selector: 'webmodule-order-panel-internet',
  templateUrl: './panel-internet.component.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PanelComponent, TablerIconsModule, NgClass, InputPanelComponent, SkeletonScreenComponent, CurrencyPipe, AlertComponent, DatePipe, TranslatePipe],
  standalone: true,
})
export class PanelInternetComponent extends AbstractBasePanelComponent<PackageDto> implements OnInit {
  @Input() internetTypeSelection = true;
  @Input() defaultInternetType: InternetType = 'all-in-one';
  internetType = signal<InternetType>(this.defaultInternetType);
  readonly availablePackages = computed(() => this.packageService.packages().filter((item) => kebabCase(item.type) === this.internetType()));

  constructor() {
    super();

    effect(() => {
      if (!this.select()) {
        this.setSelected(this.availablePackages()[0], 'internet');
      }

      if (this.select() !== this.packageService.selected()) {
        const selected = this.select();
        this.packageService.select(selected);
        this.promotionService.selectedPackageId.set(selected?.id ?? null);
        this.cartService.activationPrice.set(selected?.activationPrice ?? '');
      }
    });
  }

  ngOnInit() {
    this.internetType.set(this.defaultInternetType);
  }

  getBarSpeed(current: number) {
    const maxSpeed = maxBy(this.availablePackages(), 'download');
    if (!maxSpeed?.download) {
      return 0;
    }

    return 100 - (current / maxSpeed.download) * 100;
  }

  selectInternetType(type: InternetType) {
    this.internetType.set(type);
    this.setSelected(this.availablePackages()[0], 'internet');
  }

  hasPromotion(packageId: number) {
    return this.promotionService.getPackagePromotions(packageId);
  }

  getDiscount(packageId: number, optionId: number) {
    return this.promotionService.getDiscount(packageId, optionId);
  }
}
